import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  passwordExpired: false,
  expiredAt: null,
};

const passwordSlice = createSlice({
  name: "password",
  initialState,
  reducers: {
    setPasswordExpired(state, action) {
      state.passwordExpired = true;
      state.expiredAt = action.payload;
    },
    resetPasswordState(state) {
      state.passwordExpired = false;
      state.expiredAt = null;
    },
  },
});

export const { setPasswordExpired, resetPasswordState } = passwordSlice.actions;
export default passwordSlice.reducer;
